import React from 'react';
import styled, { css } from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  display: flex;
  position: relative;
  padding-bottom: 10px;
  margin-top: 12px;
  align-items: center;
`;

export const InnerWrap = styled.div`
  ${({ isAccessories, allowMultiple }) => `
  display: flex;
  padding-right: ${isAccessories && allowMultiple ? '80px' : 0};
  position: relative;
  width: 100%;

  @media ${minBp('additional.mobile')} {
    flex: 3;
    margin-right: 0;
  }

  @media ${minBp('desktop')} {
    align-items: center;
    padding-right: 0;
  }
`}
`;

export const BikeImageWrap = styled.div``;

export const Swatch = styled.div`
  background-color: white;
  background-image: url('${({ swatchImage }) => swatchImage}');
  background-size: cover;
  background-position: center center;
  height: 46px;
  width: 60px;
  min-width: 60px;
  border: 1px solid #d4d3d1;

  @media ${minBp('tablet')} {
    width: 90px;
    min-width: 90px;
    height: 70px;
  }
`;

export const AccessoryImage = styled.div`
  background-color: white;
  background-image: url('${({ backgroundImage }) => backgroundImage}');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 46px;
  width: 60px;
  min-width: 60px;
  border: 1px solid #d4d3d1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${minBp('tablet')} {
    width: 90px;
    min-width: 90px;
    height: 70px;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) { 
    position: relative;
    min-width: none;
    height: 70px;
    width: 90px;
    top: 0;
    margin-top: 0;
  }

  svg {
    max-width: 50%;
    height: 100%;
  }
`;

export const ItemsContentWrapper = styled.div`
  margin: 0 0 0 11px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${minBp('additional.mobile')} {
    margin: 0 11px;
  }

  @media ${minBp('desktop')} {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const ItemsContent = styled.div`
  ${({ isAccessories }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: ${isAccessories ? '20px' : '0'}
    
    @media ${minBp('additional.mobile')} { 
      margin-right: 0;
    }

    @media ${minBp('desktop')} {
      flex: 2;
      flex-direction: row;
      justify-content: flex-start;
      padding-right: 20px;
    }
`};
`;

export const HeaderTitle = styled.span`
  color: #000;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 15px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};

  @media ${minBp('tablet')} {
    line-height: 18px;
    font-size: 16px;
  }
`;

export const Name = styled.span`
  margin-bottom: 2px;
  font-size: 12px;
  color: #000;
  text-transform: uppercase;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};

  @media ${minBp('tablet')} {
    margin-bottom: 0;
    font-size: 16px;
  }
`;

export const SummaryContainer = css`
  display: flex;
  align-items: center;
  flex: 1;

  @media ${minBp('desktop')} {
    justify-content: flex-start;
    flex: 3;
  }
`;

export const SummaryInner = css`
  padding-right: 10px;

  @media ${minBp('desktop')} {
    border-left: 1px solid #a7a9ac;
    padding-left: 10px;
    padding-right: 20px;
  }
`;

export const PricingContainer = styled.div`
  ${({ showAllColours }) => `
  ${SummaryContainer}
  flex: none;
  `}
`;

export const PricingInner = styled.div`
  ${SummaryInner}
`;

export const FittingWrap = styled.div`
  ${({ isAccessories }) => `
    display: flex;
    margin-top: 3px;

    @media ${minBp('tablet')} {
      display: flex;
    }

    @media ${minBp('desktop')} {
      flex: 3;
      ${isAccessories ? 'margin-right: 100px' : null};
    }
  `}
`;

export const FittingContainer = styled.div`
  ${({ fittingTime }) => `
    ${SummaryContainer}
    flex: ${fittingTime ? 1 : 'none'};
    width: ${fittingTime ? 'auto' : '60px'};
    border-left: ${fittingTime ? '1px solid #a7a9ac' : ''};
    padding-left: ${fittingTime ? '15px' : '0'};

    @media ${minBp('tablet')} {
      width: ${fittingTime ? 'auto' : '75px'};
    }

    @media ${minBp('tabletLarge')} { 
      width: ${fittingTime ? 'auto' : '80px'};
    }

    @media ${minBp('desktop')} {
      border-left: 1px solid #a7a9ac;
      border-right: 0px;
      padding-left: 5px;
      flex: ${fittingTime ? 1.2 : 0.8};
      justify-content: flex-start;
    }
  `}
`;
export const FittingInner = styled.div`
  ${({ fittingTime }) => `
    ${SummaryInner}
    display: flex;
    align-items: center;
    padding-right: ${fittingTime ? '0px' : '5px'};

    @media ${minBp('desktop')} {
      border: none;
      padding-right: ${fittingTime ? '0px' : '5px'};
    }

    svg {
      margin-right: 5px;
      height: 13px;
      width: 13px;

      @media ${minBp('desktop')} {
        border: none;
      }
    }
  `};
`;

export const Price = styled.span`
  font-size: 12px;

  @media ${minBp('tablet')} {
    font-size: 16px;
  }
`;

export const CTAStyles = css`
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  border: 1px solid black;
  height: 32px;
  min-width: 100px;
  width: auto;
  background: transparent;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  flex: 1;
  font-size: 12px;
  line-height: 1;
  max-width: 100px;
  padding-top: 2px;
  padding: 0;
`;

export const EditButton = styled.button`
  ${CTAStyles}
  min-width: 110px;
  max-width: 110px;
`;

export const SelectButton = styled.button`
  ${CTAStyles}
  flex: 1;

  ${({ selected }) => `
    background-color: ${selected ? '#000' : 'transparent'};
    color: ${selected ? '#FFF' : '#000'};
  `}
`;

export const QuantityWrap = styled.div`
  ${({ allowMultiple }) => `
    display: flex;
    align-items: center;
    justify-content: ${allowMultiple ? 'center' : 'flex-end'};
    max-height: 20px;
    position: absolute;
    right: ${allowMultiple ? '-10px' : 0};
    top: 50%;
    transform: translateY(-50%);
    width: 93px;

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      width: 117px;
    }

    @media ${minBp('desktop')} {
      padding-left: 10px;
      
      &:not(:root:root) {
        padding-left: 0;
      }
    }

    svg {
      &:hover {
        cursor: pointer;
      }
    }
  `}
`;

export const QuantityButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0 7px;

  @media ${minBp('additional.mobile')} {
    padding: 0 11px;

    @supports (-webkit-overflow-scrolling: touch) {
      padding: 0 7px;
    }
  }

  @media ${minBp('tablet')} {
    padding: 0 11px;

    &:last-of-type {
      padding-right: 23px;
    }
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    &:last-of-type {
      padding-right: 0;
    }
  }

  svg {
    height: 19px;
    width: 19px;
  }

  &:disabled {
    cursor: default;

    svg > path {
      fill: #a7a9ac;
    }
  }
`;

export const Quantity = styled.button`
  border: 1px solid;
  min-width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background: transparent;
`;
